module.exports = __webpack_public_path__ + "img/telecom.e64e37c5.svg";